import { Container } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';
import photos  from '../data/photos';
import { ReactPictureGrid } from 'react-picture-grid';

export default function Gallerie() {
	const sizing = [
	   "small", 
	   "small",
	   "small", 
	   "small",
	   "small", 
	   "small",
	   "small",
	   "small",
	   "small", 
	   "small",
	   "big",
	   "small",
	   "small",
	   "big",
	   "small",
	   "wide",
	   "small",
	   "wide",
	   "small",
	   "small"
	]; 
	return(
	<Container id="gallery" className="mb-5">
	  	<TypeAnimation
		    cursor={false}
		    sequence={[ 
		       'Gallery', 1000, 
		       'Digital Artworks', 1000, 
		       'Catalog', 1000, 
		       'Galerie', 1000, 
		       'Kunstwerk', 1000, 
		       'Gallery', 1000]}
		    wrapper="p"
		    className="about-me-label mt-1 text-center"
	    />

	<ReactPictureGrid 
	   data={photos} 
	   showTitle 
	   gap={10}
	   showPreview={true}
	   closeOnClick={true}
	   showImageInfo={true}
	   pattern={sizing}
	/>

	</Container>		
	);
};